export default __webpack_public_path__ + "static/media/DNo.13-3.25e34018.jpg";